export default "__VITE_ASSET__DTQ0hmmf__"